<template>
    <div>
        <q-list no-border class="menu-list">
            <q-item link item exact class="big" :to="{ name: 'home' }">
                Início
            </q-item>
            <q-item v-for="menu in userMenu" :key="menu.name" link item exact class="big" :to="menu.slug">
                {{ $T(menu.name) }}
            </q-item>

            <q-item-separator class="nav-separator q-my-lg q-ml-md" />
            <!--
            Esses dois primeiros ai embaixo deveriam ser dinâmicos tb. Um "submenu"
            O "minha conta" deve verificar se já está logado v-if.
            Assim como o login/esqueci a senha, logout
            -->
            <q-item link :to="{name: 'contests'}" v-if="total > 0">{{ $T('passatempos') }}</q-item>
            <q-item link :to="{ name: 'contact-us' }">{{ $T("contact us") }}</q-item>
            <q-item link :to="{ name: 'tec' }">{{ $T("terms ans conditions") }}</q-item>
            <q-item link to="/profile">{{ $T("my account") }}</q-item>
        </q-list>

        <div class="nav-actions">
            <div>
                <q-btn
                    outline
                    color="primary"
                    class="full-width q-my-md"
                    :label="$T('close your session')"
                    link
                    @click.native="logout"
                    v-if="user"
                />

                <q-btn
                    outline
                    color="primary"
                    class="full-width q-my-md"
                    :label="$T('start your session')"
                    @click.prevent="$login()"
                    v-else
                />
            </div>

            <div class="version">
                <small>© Portal Fit - V{{ getVersion() }}</small>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters } from 'vuex'
    import { loadMessages } from '../plugins/i18n'

    import {
        QList,
        QListHeader,
        QItem,
        QItemSeparator,
        QBtn,
        QField,
        QInput,
        Cookies
    } from 'quasar-framework'

    export default {
        components: {
            QList,
            QListHeader,
            QItem,
            QItemSeparator,
            QBtn,
            QField,
            QInput
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                locale: 'lang/locale',
                locales: 'lang/locales',
                userMenu: 'userMenu/userMenu'
            }),

            menus() {
                return window.config.menus
            }
        },

        data() {
            return {
                query: '',
                total: 0,
                portal_base: ''
            }
        },

        methods: {
            async logout() {
                // Log out the user.
                this.$router.push({name:'home'})
                await this.$store.dispatch('auth/logout')
                window.location.href = 'logout'
                // Redirect to login.
            },

            setLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale);

                    this.$store.dispatch('lang/setLocale', {locale})
                }
            },

            search() {
                this.$router.push({ name: 'sports.search', params: {query: this.query} })
            },

            getVersion() {
                this.portal_base = Cookies.get('portal')
                axios.get(`${config.appUrl}/${this.portal_base}/${null}/passatempos?lang=${this.locale}`)
                  .then(response => this.total = response.data.content.page.total)
                return `${config.appVersion}`
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue